<template>
    <van-popup round
               v-model="show"
               @closed="resetTitle">
        <div class="body">
            <div class="modalTitle">{{ title || "打开知东莞APP参与互动" }}</div>
            <div class="btns">
                <div class="btn"
                     @click="close">取消</div>
                <div class="btn open"
                     @click="openApp"
                     id="down">打开APP</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: "DownModal",
    data() {
        return {
            show: false,
            title: "",
            linkParams: {
                id: "usr1kva5smt2abij",
                data: "",
                selector: "#down",
                timeout: 200,
                useOpenInBrowerTips: "default",
                lazy: false,
                auto: false,
            },
            audioData: "",
        };
    },
    created() {
        this.addLinkDataULink()
    },
    methods: {
        open(title) {
            if (typeof title == "string") this.title = title;
            this.show = true;
        },
        close() {
            this.show = false;
        },
        resetTitle() {
            this.title = "";
        },
        openApp() {
            // 配置ulink参数
            ULink({
                ...this.linkParams,
            });
        },
        addLinkDataULink() {
            this.$bus.$on("linkDataUpdateModel", (data) => {
                this.initULinkModel(data);
            });
        },
        initULinkModel(data) {
            ULink({
                id: "usr1kva5smt2abij",
                data: {
                    ...data,
                },
                selector: "#down",
                timeout: 2000,
                useOpenInBrowerTips: "default",
                lazy: false,
                auto: false,
                useClipboard: false,
                onready: function (ctx) {},
            });
        },
    },
};
</script>

<style scoped lang="less">
.body {
    z-index: 999999;
    text-align: center;
    padding: 10px;
    width: 270px;

    width: 88vw;
    height: 160px;
    // max-width: 640px;
    // padding: 0px 20px;
    // top: calc(50vh - 80px);
    // z-index: 1002;
    .modalTitle {
        width: 100%;
        //height: 100%;
        line-height: 100px;
        white-space: nowrap;
    }
    .btns:extend(.flex-btw) {
        margin-top: 10px;
        .btn {
            width: 45%;
            // border: 1px solid #d4d4d4;
            padding: 8px;
            font-size: 16px;
            color: #939393;
            // border-radius: 100px;
        }
        .open {
            // background-color: @base-color;
            color: rgb(254, 74, 105);
            border: none;
        }
    }
}
</style>
